import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operationsComponent from './operations.component';
import dataTable from 'angular-material-data-table';

let operationsModule = angular
  .module('operations', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('operations', {
      url: '/operations',
      component: 'operations',
      parent: 'main',
      data: {
        permissions: {
          only: ['AUTHORIZED'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('operations', operationsComponent).name;

export default operationsModule;
